var _style, _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 576 576",
    viewBox: "0 0 576 576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#66BE69;}\n\t.st1{fill:#FCD306;}\n\t.st2{fill:#3BC5F3;}\n\t.st3{fill:#EF364D;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m45.6 533.1v-496.3c0-17 18.3-27.6 33.1-19.2l440.1 251.3c15.1 8.6 15 30.4-0.1 38.9l-437 246.4c-16.2 9.1-36.1-2.6-36.1-21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m518.8 268.9l-119.2-68.1-346.8 349.5c7.3 7.1 18.8 9.5 28.9 3.9l437-246.4c15.1-8.6 15.2-30.3 0.1-38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.3,21c-4.1,3.9-6.7,9.4-6.7,15.9v496.3c0,18.5,19.9,30.1,36,21l316.3-178.3L52.3,21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m312.7 288.3l-259 262.9c7.3 6.5 18.3 8.5 28 3l318.3-179.4-87.3-86.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.457be6f8bf39fa565356d69c621d3ab5.svg";
export { ForwardRef as ReactComponent };